<template>
  <div class="valentine-day">
    <img
      class="btn-image"
      src="./images/active.png"
      alt=""
      v-show="status === 0 || !userInfo"
      @click="getCoupons()"
    />
    <img
      class="btn-image"
      src="./images/not-active.png"
      v-show="status != 0 && userInfo"
    />
    <img src="./images/bg.png" alt="" />
    <el-dialog
      class="valentine-day-dialog-bg"
      :visible.sync="successDialog"
      title=""
      append-to-body
      :show-close="false"
      top="25vh"
      @click.native="goBack"
    >
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ValentineDay2',
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
      status: null,
      successDialog: false,
      htmlOriginalFontSize: null
    };
  },
  methods: {
    // 獲取詳情
    async getDetail() {
      try {
        /*
         * @param  type 0/查询 1/领取
         * @return  0/未领取 1/领取成功 2/已领取 3/活动不在有效期
         */
        const { data } = await this.$http.get('/activity/activity0214', {
          type: 0
        });
        this.status = data;
        if (data === 3) {
          this.$confirm({
            message:
              '當前活動已結束，更多福利敬請留意nicee平台，感謝您的支持呀～',
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickModal: true,
            customClass: 'dialog-center'
          }).then(() => {
            // this.$router.push({ path: '/' });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 抽獎
    async getCoupons() {
      if (!this.userInfo) {
        this.$util.Login({ redirect: this.$route.path }).then(() => {
          this.getDetail();
        });
        // this.$message('未登錄，不能領取');
      }
      if (this.status === 0) {
        try {
          const { data } = await this.$http.get('/activity/activity0214', {
            type: 1
          });
          if (data === 1) {
            this.status = 1;
            this.successDialog = true;
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    goBack() {
      this.$router.push({ path: '/' });
    },
    // 初始化根字体大小
    initHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      this.htmlOriginalFontSize = html.style.fontSize;
      html.style.fontSize = '0.625vw'; //设计稿宽1920 根字体12px
    },
    // 重置根字体大小
    resetHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      html.style.fontSize = this.htmlOriginalFontSize;
    }
  },
  created() {
    this.initHtmlFontSize();
    this.getDetail();
  },
  destroyed() {
    this.resetHtmlFontSize();
  }
};
</script>
<style lang="scss" scoped>
.valentine-day {
  width: 100%;
  height: 100vh;
  overflow: auto;
  position: relative;
  img {
    width: 100%;
    max-width: 100%;
  }

  .btn-image {
    position: absolute;
    transform: rotate(38.689858deg);
    top: 44.723rem;
    left: 47.597rem;
    width: 48.414rem;
    height: 45.106rem;
  }
}
</style>
<style lang="scss">
.valentine-day-dialog-bg {
  .el-dialog {
    background: url('./images/order-bg.png') no-repeat center top;
    background-size: 100% auto;
    width: 52rem;
    height: 32.833rem;
  }
}
</style>
